import React from 'react';
import { useLang } from '../i18n';

function GradeSelection({ grade, onUnitSelect, onBack }) {
  const { t } = useLang();
  const units = Array.from({ length: 8 }, (_, i) => i + 1);
  const gradeNumber = grade === 'grade5' ? 5 : 6;

  return (
    <div className="grade-selection-screen">
      <h2>{t.gradeUnitSelection(gradeNumber)}</h2>
      <div className="unit-buttons-container">
        {units.map(unitNumber => (
          <button
            key={unitNumber}
            className="unit-button-image"
            onClick={() => onUnitSelect(grade, unitNumber)}
            style={{
              backgroundImage: `url("${process.env.PUBLIC_URL}/assets/menu-buttons/topic-buttons/grade_${gradeNumber}_unit_${unitNumber}.png")`
            }}
          >
            <span className="unit-button-label">{t.unit(unitNumber)}</span>
          </button>
        ))}
      </div>
    </div>
  );
}

export default GradeSelection;
